const getName = (context, object) => {
  context.commit("DASHBOARD_NAME_UPDATED", object.name);
};

const setPerPage = (context, perPage) => {
  context.commit("SET_DASHBOARD_TASK_PER_PAGE", perPage);
};

const selectTask = (context, task) => {
  context.commit("SELECT_TASK", task);
};

const deselectTask = (context, task) => {
  context.commit("DESELECT_TASK", task);
};

const deselectAllTasks = (context) => {
  context.commit("DESELECT_ALL_TASKS");
};

const setLabelIds = (context, labelIds) => {
  context.commit("SET_LABEL_IDS", labelIds);
};

export default {
  getName,
  setPerPage,
  selectTask,
  deselectTask,
  deselectAllTasks,
  setLabelIds,
};
